import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import bg1 from "../../assets/images/bg/ABOUT.jpg";
import bg from "../../assets/images/bg/ABOUT-m.jpg";
import Activity from "../../assets/images/language/Activities.png";
import Madhu from "../../assets/images/about/madhu.png";
import Umasree from "../../assets/images/about/Umasree.png";
import Madhukar from "../../assets/images/about/Madhukar.png";
import AboutPhoto from "../../assets/images/about/about.png";

export default function About() {
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [bg, bg1]);

  const TextWithEllipsis = ({ text, limit }) => {
    const [isTruncated, setIsTruncated] = useState(true);

    const truncatedText =
      text.length > limit ? text.substring(0, limit) + "..." : text;

    return (
      <p className="para-desc text-muted ">
        {isTruncated ? truncatedText : text}
        {text.length > limit && (
          <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => setIsTruncated(!isTruncated)}
          >
            {/* {isTruncated ? " " : " Show Less"} */}
          </span>
        )}
      </p>
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState();

  const handleShowModal = (content, name, image) => {
    setModalContent(content);
    setName(name);
    setImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const madhuContent = `Madhu Malavalli born in Agasanapura, Mandya district, began his career in the automotive industry after completing ITI training. However, his passion for theatre led him to become actively involved in the theatre world over the past 16 years. He has acted in over 60 productions alongside eminent theatre personalities such as Mandya Ramesh, B. Suresha, and C. Narayan Swamy, among others. As a director, he has helmed over 15 plays, including Aalapa, Taskara, Kayakada Satyakka, Madhura Mandodari, Gange Gowri Prasanga, and Ashwatthaman. Additionally, he has worked as a theatre lighting artist for over 350 programs. Madhu Malavalli founded Ranga Bandi, an organization dedicated to theatre, and has been conducting free summer camps for 120 to 150 government school children in the Malavalli region for the past 6 years. These camps focus on theatre activities and youth workshops, and Ranga Bandi has conducted programs in districts like Mysore, Mandya, Kalburgi, and Bangalore. His extensive experience includes working with children and youth through summer camps and workshops, notably with Raja Maja Summer Camp, Kalakalarava, and Jana Mana Cultural Foundation. With experience at Rangayana, Dharwad, and Mysore Kiru Ranga Mandira, he has contributed as a technician in the Sound and Light division. Contact: 70229 40964, madhumalavalli0314@gmail.com.`;
  const umasreeContent = `Umashree G from Kudligi in Ballari district, has been working in theatre for 14 years. She is the first student from Sanehalli and has worked as an actress and assistant director at Rangayana Kalaburagi, collaborating with renowned theatre personalities like Chidambara Rao Jambe, Bhagirathi Bai Kadam, and Mahesh Patil. Umasree is proficient in Kamsale Veergase and Yakshagana dance forms and is currently directing for the Rangabandi team. Some of her directed plays include Kempu Hoo, Hanchina Mane Parasappa, Dhanvantari Chikitse, Makkala Raja, Hemareddi Mallamma, Guddadiligala Kathi, Gange Gowri Prasanga, Kindari Jogi, Nanibhattana Svargada Kanasu, Ambedkar, Chandragupta Maurya and many more.`;
  const madhukarContent = `Madhukar Malavalli is a Ninasam graduate and holds a diploma in folk art and journalism. He has been actively involved in amateur theatre and has worked professionally in children's theatre. Having collaborated with various theatre groups across the country, he has been serving as a theatre teacher at Adarsha School, Yelandur, Chamarajanagar district, for the past 16 years. He has published two collections of poetry and several articles and stories in various newspapers.`;

  const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
  `;

  const ItemsContainer = styled.div`
    font-size: 17px;
    background-color: #ffc10712;
    padding: 2rem;
    border-radius: 25px;
    box-shadow: 3px 6px 17px #21252942;
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
  `;

  const Item = styled.div`
    flex: 1 1 calc(25% - 20px); /* 4 items per row with 10px margin */
    margin: 10px;
    text-align: center;

    @media (max-width: 1200px) {
      flex: 1 1 calc(33.33% - 20px); /* 3 items per row for large screens */
    }

    @media (max-width: 992px) {
      flex: 1 1 calc(50% - 20px); /* 2 items per row for medium screens */
    }

    @media (max-width: 576px) {
      flex: 1 1 calc(100% - 20px); /* 1 item per row for small screens */
    }
  `;

  const items = [
    "1 . Theatre workshops",
    "2 . Playwriting workshops",
    "3 . Summer camps for children",
    "4 . Workshops on folk art forms",
    "5 . Award ceremony for achievers",
    "6 . Lecture programs by guest speakers",
    "7 . Theatre experiments and performances",
    "8 . Organization of National Theatre Festival",
    "9 . Global performances of plays created by children from Malavalli",
    "And many more...",
  ];

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-left nav-light"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: isMobile ? "2rem" : "",
        }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title mb-2 text-white title-dark">
                  Ranga Bandi ~ About
                </h3>
                <p
                  className="para-desc mx-auto text-white-50"
                  style={{ display: isMobile ? "none" : "block" }}
                >
                  Theatre bridges hearts and minds, weaving unity from diversity
                  through the art of storytelling.
                </p>

                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li
                      style={{ color: "#B9B569" }}
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Ranga Bandi ~ About
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative">
        <div className="shape overflow-hidden text-color-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6">
              <img src={AboutPhoto} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div
                className="section-title ms-lg-5"
                style={{ marginBottom: "3rem" }}
              >
                <h5>Rangabandi Malavalli</h5>
                <hr />
                <p className="para-desc text-muted justify">
                  Rangabandi Malavalli, rooted in the culturally rich town of
                  Malavalli in Karnataka’s Mandya district, is a dedicated
                  theatre organization with a focus on preserving and promoting
                  folk traditions, children’s theatre, and inclusive workshops.
                  Established in 2018 and registered as a trust in 2022,
                  Rangabandi has become a vibrant hub for theatrical innovation
                  and community engagement.
                </p>
                <p className="para-desc text-muted justify">
                  The organization prioritizes creating platforms for folk
                  theatre and conducts workshops across all age groups, with a
                  special emphasis on empowering women through theatre.
                  Rangabandi’s initiatives include theatre workshops,
                  experimental performances, playwriting camps, and hosting
                  prestigious national theatre festivals. The team is also
                  committed to nurturing young talent through its summer camps
                  for children and organizing productions showcasing their
                  creativity.
                </p>
                <p className="para-desc text-muted justify">
                  Having performed in various districts across Karnataka and
                  participated in numerous national and regional theatre
                  festivals, Rangabandi’s commitment to artistic excellence is
                  unwavering. The organization frequently updates its website to
                  highlight the latest events and programs, offering audiences a
                  glimpse into its dynamic activities. With a deep connection to
                  its roots and a vision for a culturally enriched future,
                  Rangabandi continues to inspire and innovate in the world of
                  theatre.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            position: "relative",
            display: "inline-block",
            paddingBottom: "10px",
          }}
        >
          <h4 style={{ margin: 0 }}>Our Team</h4>
          <div
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "100%",
              height: "2px",
              backgroundColor: "black",
            }}
          ></div>
        </div>
      </div>

      <section className="section" style={{ marginBottom: "4rem" }}>
        <div
          className="container"
          style={{
            backgroundColor: "white",
            boxShadow: "3px 6px 17px #00000038",
            borderRadius: "6px",
          }}
        >
          <div className="row" style={{ padding: "2rem" }}>
            <div className="col-lg-4 col-md-4">
              <div
                style={{
                  height: "300px",
                  width: "300px",

                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={Madhu}
                  alt="Umasree"
                  style={{
                    height: "100%",
                    width: "auto",
                    objectFit: "cover",
                  }}
                />
              </div>

              <div style={{ padding: "2rem" }}>
                <TextWithEllipsis text={madhuContent} limit={200} />
                <h5>Madhu Malavalli</h5>
                <Button
                  variant="link"
                  style={{ color: "#B9B569" }}
                  onClick={() =>
                    handleShowModal(madhuContent, "Madhu Malavalli", Madhu)
                  }
                >
                  Read More
                </Button>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div style={{ padding: "2rem" }}>
                {" "}
                <TextWithEllipsis text={umasreeContent} limit={200} />
                <h5>Umashree G</h5>
                <Button
                  variant="link"
                  style={{ color: "#B9B569" }}
                  onClick={() =>
                    handleShowModal(umasreeContent, "Umasree Ji", Umasree)
                  }
                >
                  Read More
                </Button>
              </div>

              <div
                style={{
                  height: "300px",
                  width: "300px",

                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={Umasree}
                  alt="Umasree"
                  style={{
                    height: "100%",
                    width: "auto",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div
                style={{
                  height: "300px",
                  width: "300px",

                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={Madhukar}
                  alt="Madhukar"
                  style={{
                    height: "100%",
                    width: "auto",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div style={{ padding: "2rem" }}>
                <TextWithEllipsis text={madhukarContent} limit={200} />
                <h5>Madhukar Malavalli</h5>
                <Button
                  variant="link"
                  style={{ color: "#B9B569" }}
                  onClick={() =>
                    handleShowModal(
                      madhukarContent,
                      "Madhukar Malavalli",
                      Madhukar
                    )
                  }
                >
                  Read More
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>{name}</Modal.Title>
          </Modal.Header>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img style={{ height: "350px", borderRadius: "17%" }} src={image} />
          </div>
          <Modal.Body>{modalContent}</Modal.Body>
          <Modal.Footer>
            <Button
              style={{
                backgroundColor: "#B9B569",
                border: "1px solid #B9B569",
              }}
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </section>

      <hr />

      <section>
        <div style={{ padding: "1.5rem" }}>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    paddingBottom: "10px",
                  }}
                >
                  <h4 style={{ margin: 0 }}>
                    Activities of Rangabandi Malavalli &reg;
                  </h4>
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      bottom: 0,
                      width: "100%",
                      height: "2px",
                      backgroundColor: "black",
                    }}
                  ></div>
                </div>
              </div>

              <section>
                <div className="row" style={{ alignItems: "center" }}>
                  <Container className="col-lg-12 col-md-12">
                    <ItemsContainer>
                      {items.map((item, index) => (
                        <Item key={index}>{item}</Item>
                      ))}
                    </ItemsContainer>
                  </Container>
                  <div className="col-lg-12 col-md-12">
                    <img src={Activity} className="img-fluid" alt="" />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
